module.exports = __webpack_public_path__ + "img/doar.685024c8.svg";